function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h20v20H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.254 10c0-4.81 3.915-8.712 8.744-8.712 4.833 0 8.748 3.903 8.748 8.712 0 4.813-3.915 8.712-8.748 8.712-4.83 0-8.744-3.899-8.744-8.712zm13.244-2.89V4.73c-3.581-2.373-6.554-1.828-8.056-.728-2.34 1.71-2.897 5.525.778 7.067 1.781.747 3.271.839 4.118 1.204.982.421 1.554 2.361-.93 2.794-1.952.338-4.018-.814-5.663-2.83.016.036 0 2.747 0 2.747 2.746 2.29 7.543 3.235 10.05-.525 1.197-1.792.386-4.308-1.136-5.155-2.679-1.49-4.141-.79-5.608-2.201-.882-.847-.39-2.385 1.542-2.322 2.611.084 4.905 2.33 4.905 2.33z",
  fill: "#50AA58"
}))));